import axios from 'axios';


let token;
let api;
  //  let baseURL = 'https://localhost:44392/api';
    let baseURL = 'https://api.hosseinienajafabadiha.com/api';
  //   let baseURL = 'http://api.hosseinienajafabadiha.com/api';
const initValues = () => {
    try {
        token = localStorage.getItem('token');
    }
    catch {
        token = '';
    }
    api = axios.create({
        baseURL: baseURL,
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Agency': localStorage.getItem('agency'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
}

const initValuesForMultiPart = () => {
    try {
        token = localStorage.getItem('token');
    }
    catch {
        token = '';
    }
    api = axios.create({
        baseURL: baseURL,
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Agency': localStorage.getItem('agency'),
            'Content-Type': "multipart/form-data"
        },
    });
}
const request = {
    get: (endpoint, options = {}) => {
        initValues();
        return api.get(endpoint, options);
    },
    post: (endpoint, data, options = {}) => {
        initValues();
        return api.post(endpoint, Object.assign({}, data), options);
    },
    put: (endpoint, options = {}) => {
        initValues();
        return api.put(endpoint, options);
    },
    patch: (endpoint, options = {}) => {
        initValues();
        return api.patch(endpoint, options);
    },
    delete: (endpoint, data, options = {}) => {
        initValues();
        var d = { data: data };
        return api.delete(endpoint, Object.assign({}, d), options);
    },
    options: (endpoint, options) => {
        initValues();
        return api.options(endpoint, options);
    },

    head: (endpoint, options) => {
        initValues();
        return api.head(endpoint, options);
    },
    postMultiPart: (endpoint, options) => {
        initValuesForMultiPart();
        return api.post(endpoint, options);
    },
};

export default request;